import React from 'react'
import HiddenField from './Hidden'
import BooleanField from './Boolean'
import TextField from './Text'
import ImmutableField from './Immutable'
import ProductSelectField from './ProductSelect'
import DateTimeField from './DateTime'
import DropdownField from './Dropdown'

const fields = {
  boolean: BooleanField,
  hidden: HiddenField,
  immutable: ImmutableField,
  text: TextField,
  product: ProductSelectField,
  datetime: DateTimeField,
  dropdown: DropdownField,
}

const Field = (props) => {
  const Component = fields[props.field.type] || TextField

  return <Component {...props} />
}

export default Field



// WEBPACK FOOTER //
// ./src/components/fields/index.js